import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../styles/dashboard-styles';
import Typography from '@material-ui/core/Typography';
import Spinner from './Spinner';

function Loading(props) {
  const { classes } = props;
  return (
    <div className={classes.loading}>
      <Spinner className="lds-ripple main-loading" />
      <Typography
        component="p"
        variant="h6" >
        Loading...
      </Typography>
    </div>
  )
}
Loading.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading.js